// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__Bds_A","content":"styles_content__2_S0W","selectAll":"styles_selectAll__1I7jB"};